"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamConverter = void 0;
const ponyfill_1 = require("web-streams-polyfill/ponyfill");
class StreamConverter {
    static toArrayBuffer(readableStream) {
        return __awaiter(this, void 0, void 0, function* () {
            const reader = readableStream.getReader();
            const chunks = [];
            let result = yield reader.read();
            while (!result.done) {
                chunks.push(result.value);
                result = yield reader.read();
            }
            const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
            const buffer = new Uint8Array(totalLength);
            let offset = 0;
            for (const chunk of chunks) {
                buffer.set(chunk, offset);
                offset += chunk.length;
            }
            return buffer.buffer;
        });
    }
    static fromArrayBuffer(arrayBuffer) {
        return __awaiter(this, void 0, void 0, function* () {
            return new ponyfill_1.ReadableStream({
                start(controller) {
                    const view = new DataView(arrayBuffer);
                    let offset = 0;
                    while (offset < arrayBuffer.byteLength) {
                        controller.enqueue(view.getUint8(offset));
                        offset++;
                    }
                    controller.close();
                },
            });
        });
    }
    static fromAsyncIterable(asyncIterable) {
        return new ponyfill_1.ReadableStream({
            start(controller) {
                let offset = 0;
                function pushData() {
                    var e_1, _a;
                    return __awaiter(this, void 0, void 0, function* () {
                        try {
                            for (var asyncIterable_1 = __asyncValues(asyncIterable), asyncIterable_1_1; asyncIterable_1_1 = yield asyncIterable_1.next(), !asyncIterable_1_1.done;) {
                                const chunk = asyncIterable_1_1.value;
                                const anyChunk = chunk;
                                controller.enqueue(anyChunk);
                                offset = offset + anyChunk.length;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return)) yield _a.call(asyncIterable_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        controller.close();
                    });
                }
                pushData();
            },
        });
    }
}
exports.StreamConverter = StreamConverter;
